module.exports = "﻿﻿<div class=\"row\" *ngFor=\"let category of categories\">\r\n    <category-tree-item [category]=\"category\" (selectedChanged)=\"onSelectedChanged()\" *ngIf=\"category.show\"></category-tree-item>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./Client/app/components/common/category.tree.view/category.tree.root.html
// module id = 1434
// module chunks = 0